import _classCallCheck from "/builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _classPrivateFieldSet from '@babel/runtime/helpers/esm/classPrivateFieldSet';
import _classPrivateFieldGet from '@babel/runtime/helpers/esm/classPrivateFieldGet';
import { throttle } from '@remirror/core-helpers';
import { setStyle } from '@remirror/core-utils';

function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);

  privateMap.set(obj, value);
}

var leftCorner = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" width=\"22\" height=\"22\" fill=\"rgba(0, 0, 0, 0.65)\" stroke=\"rgba(255, 255, 255, 0.5)\" transform=\"rotate(90)\" xmlns:v=\"https://vecta.io/nano\"><path fill-rule=\"evenodd\" d=\"M14 0a2 2 0 0 0-2 2v10H2a2 2 0 1 0 0 4h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z\"/></svg>";
var rightCorner = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" width=\"22\" height=\"22\" fill=\"rgba(0, 0, 0, 0.65)\" stroke=\"rgba(255, 255, 255, 0.5)\" transform=\"matrix(0 1 1 0 0 0)\" xmlns:v=\"https://vecta.io/nano\"><path fill-rule=\"evenodd\" d=\"M14 0a2 2 0 0 0-2 2v10H2a2 2 0 1 0 0 4h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z\"/></svg>";
var leftCornerHandle = encodeURIComponent(leftCorner);
var rightCornerHandle = encodeURIComponent(rightCorner);
var ResizableHandleType;

(function (ResizableHandleType) {
  ResizableHandleType[ResizableHandleType["Right"] = 0] = "Right";
  ResizableHandleType[ResizableHandleType["Left"] = 1] = "Left";
  ResizableHandleType[ResizableHandleType["Bottom"] = 2] = "Bottom";
  ResizableHandleType[ResizableHandleType["BottomRight"] = 3] = "BottomRight";
  ResizableHandleType[ResizableHandleType["BottomLeft"] = 4] = "BottomLeft";
})(ResizableHandleType || (ResizableHandleType = {}));

var _handle = /*#__PURE__*/new WeakMap();

var ResizableHandle = /*#__PURE__*/function () {
  function ResizableHandle(type) {
    _classCallCheck(this, ResizableHandle);

    _classPrivateFieldInitSpec(this, _handle, {
      writable: true,
      value: void 0
    });

    var wrapper = document.createElement('div');
    var handle = document.createElement('div');
    this.dom = wrapper;

    _classPrivateFieldSet(this, _handle, handle);

    this.type = type;
    this.createHandle(type);
  }

  _createClass(ResizableHandle, [{
    key: "createHandle",
    value: function createHandle(type) {
      setStyle(this.dom, {
        position: 'absolute',
        pointerEvents: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '100'
      });
      setStyle(_classPrivateFieldGet(this, _handle), {
        opacity: '0',
        transition: 'opacity 300ms ease-in 0s'
      });
      _classPrivateFieldGet(this, _handle).dataset.dragging = '';

      switch (type) {
        case ResizableHandleType.Right:
          setStyle(this.dom, {
            right: '0px',
            top: '0px',
            height: '100%',
            width: '15px',
            cursor: 'col-resize'
          });
          setStyle(_classPrivateFieldGet(this, _handle), {
            width: ' 4px',
            height: '36px',
            maxHeight: '50%',
            boxSizing: 'content-box',
            background: 'rgba(0, 0, 0, 0.65)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            borderRadius: '6px'
          });
          break;

        case ResizableHandleType.Left:
          setStyle(this.dom, {
            left: '0px',
            top: '0px',
            height: '100%',
            width: '15px',
            cursor: 'col-resize'
          });
          setStyle(_classPrivateFieldGet(this, _handle), {
            width: ' 4px',
            height: '36px',
            maxHeight: '50%',
            boxSizing: 'content-box',
            background: 'rgba(0, 0, 0, 0.65)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            borderRadius: '6px'
          });
          break;

        case ResizableHandleType.Bottom:
          setStyle(this.dom, {
            bottom: '0px',
            width: '100%',
            height: '14px',
            cursor: 'row-resize'
          });
          setStyle(_classPrivateFieldGet(this, _handle), {
            width: ' 42px',
            height: '4px',
            boxSizing: 'content-box',
            maxWidth: '50%',
            background: 'rgba(0, 0, 0, 0.65)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            borderRadius: '6px'
          });
          break;

        case ResizableHandleType.BottomRight:
          setStyle(this.dom, {
            right: '-1px',
            bottom: '-2px',
            width: '30px',
            height: '30px',
            cursor: 'nwse-resize',
            zIndex: '101'
          });
          setStyle(_classPrivateFieldGet(this, _handle), {
            height: '22px',
            width: '22px',
            backgroundRepeat: 'no-repeat',
            backgroundImage: "url(\"data:image/svg+xml,".concat(rightCornerHandle, "\") ")
          });
          break;

        case ResizableHandleType.BottomLeft:
          setStyle(this.dom, {
            left: '-1px',
            bottom: '-2px',
            width: '30px',
            height: '30px',
            cursor: 'nesw-resize',
            zIndex: '101'
          });
          setStyle(_classPrivateFieldGet(this, _handle), {
            height: '22px',
            width: '22px',
            backgroundRepeat: 'no-repeat',
            backgroundImage: "url(\"data:image/svg+xml,".concat(leftCornerHandle, "\") ")
          });
          break;
      }

      this.dom.append(_classPrivateFieldGet(this, _handle));
    }
  }, {
    key: "setHandleVisibility",
    value: function setHandleVisibility(visible) {
      var isVisible = visible || !!_classPrivateFieldGet(this, _handle).dataset.dragging;
      _classPrivateFieldGet(this, _handle).style.opacity = isVisible ? '1' : '0';
    }
  }, {
    key: "dataSetDragging",
    value: function dataSetDragging(isDraging) {
      _classPrivateFieldGet(this, _handle).dataset.dragging = isDraging ? 'true' : '';
    }
  }]);

  return ResizableHandle;
}();

var MIN_WIDTH = 50;
var ResizableRatioType;

(function (ResizableRatioType) {
  ResizableRatioType[ResizableRatioType["Fixed"] = 0] = "Fixed";
  ResizableRatioType[ResizableRatioType["Flexible"] = 1] = "Flexible";
})(ResizableRatioType || (ResizableRatioType = {}));

var _element = /*#__PURE__*/new WeakMap();

var _node = /*#__PURE__*/new WeakMap();

var _destroyList = /*#__PURE__*/new WeakMap();

var _width = /*#__PURE__*/new WeakMap();

var _height = /*#__PURE__*/new WeakMap();
/**
 * ResizableNodeView serves as a base NodeView for resizable element,
 * and cannot be directly instantiated.
 * With this base NodeView, you can resize the DOM element by dragging the handle over the image.
 *
 * @param node - the node which uses this nodeView. Must have `width` and `height` in the attrs.
 * @param view - the editor view used by this nodeView.
 * @param getPos - a utility method to get the absolute cursor position of the node.
 * @param aspectRatio? - to determine which type of aspect ratio should be used.
 * @param options? - extra options to pass to `createElement` method.
 * @param initialSize? - initial view size.
 */


var ResizableNodeView = /*#__PURE__*/function () {
  // cache the current element's size so that we can compare with new node's
  // size when `update` method is called.
  function ResizableNodeView(_ref) {
    _classCallCheck(this, ResizableNodeView);

    var _this = this;

    var node = _ref.node,
        view = _ref.view,
        getPos = _ref.getPos,
        _ref$aspectRatio = _ref.aspectRatio,
        aspectRatio = _ref$aspectRatio === void 0 ? ResizableRatioType.Fixed : _ref$aspectRatio,
        options = _ref.options,
        initialSize = _ref.initialSize;

    _classPrivateFieldInitSpec(this, _element, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _node, {
      writable: true,
      value: void 0
    });

    _classPrivateFieldInitSpec(this, _destroyList, {
      writable: true,
      value: []
    });

    _classPrivateFieldInitSpec(this, _width, {
      writable: true,
      value: undefined
    });

    _classPrivateFieldInitSpec(this, _height, {
      writable: true,
      value: undefined
    });

    var outer = this.createWrapper(node, initialSize);
    var element = this.createElement({
      node: node,
      view: view,
      getPos: getPos,
      options: options
    });
    /**
     * Only initialize `handleBottom`, `handleBottomRight`, and `handleBottomLeft` in
     * `ResizableRatioType.Flexible` mode
     */

    var types = aspectRatio === ResizableRatioType.Flexible ? [ResizableHandleType.Right, ResizableHandleType.Left, ResizableHandleType.Bottom, ResizableHandleType.BottomRight, ResizableHandleType.BottomLeft] : [ResizableHandleType.Right, ResizableHandleType.Left];
    var handles = types.map(function (type) {
      return new ResizableHandle(type);
    });

    var _iterator = _createForOfIteratorHelper(handles),
        _step;

    try {
      var _loop = function _loop() {
        var handle = _step.value;

        var handler = function handler(e) {
          _this.resizeHandler(e, view, getPos, handle);
        };

        handle.dom.addEventListener('mousedown', handler);

        _classPrivateFieldGet(_this, _destroyList).push(function () {
          return handle.dom.removeEventListener('mousedown', handler);
        });

        outer.append(handle.dom);
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var setHandleVisibe = function setHandleVisibe() {
      handles.forEach(function (handle) {
        return handle.setHandleVisibility(true);
      });
    };

    var setHandleInvisible = function setHandleInvisible() {
      handles.forEach(function (handle) {
        return handle.setHandleVisibility(false);
      });
    };

    outer.addEventListener('mouseover', setHandleVisibe);
    outer.addEventListener('mouseout', setHandleInvisible);

    _classPrivateFieldGet(this, _destroyList).push(function () {
      return outer.removeEventListener('mouseover', setHandleVisibe);
    }, function () {
      return outer.removeEventListener('mouseout', setHandleInvisible);
    });

    outer.append(element);
    this.dom = outer;

    _classPrivateFieldSet(this, _node, node);

    _classPrivateFieldSet(this, _element, element);

    this.aspectRatio = aspectRatio;
  }
  /**
   * `createElement` - a method to produce the element DOM element for this prosemirror node.
   * The subclasses have to implement this abstract method.
   */


  _createClass(ResizableNodeView, [{
    key: "createWrapper",
    value: function createWrapper(node, initialSize) {
      var outer = document.createElement('div');
      outer.classList.add('remirror-resizable-view');
      outer.style.position = 'relative';

      if (initialSize) {
        setStyle(outer, {
          width: normalizeSize(initialSize.width),
          aspectRatio: "".concat(initialSize.width, " / ").concat(initialSize.height)
        });
      } else {
        setStyle(outer, {
          width: normalizeSize(node.attrs.width),
          aspectRatio: "".concat(node.attrs.width, " / ").concat(node.attrs.height)
        });
      }

      setStyle(outer, {
        maxWidth: '100%',
        minWidth: "".concat(MIN_WIDTH, "px"),
        // By default, inline-block has "vertical-align: baseline", which makes
        // the outer wrapper slightly taller than the resizable view, which will
        // causes layout shift. So we need to set `vertical-align` to avoid this.
        verticalAlign: 'bottom',
        display: 'inline-block',
        // necessary so the bottom right handle is aligned nicely
        lineHeight: '0',
        // make sure transition time is larger then mousemove event's throttle time
        transition: 'width 0.15s ease-out, height 0.15s ease-out'
      });
      return outer;
    }
  }, {
    key: "resizeHandler",
    value: function resizeHandler(e, view, getPos, handle) {
      var _this2 = this;

      var _classPrivateFieldGet2, _classPrivateFieldGet3;

      e.preventDefault();
      handle.dataSetDragging(true);
      _classPrivateFieldGet(this, _element).style.pointerEvents = 'none';
      var startX = e.pageX;
      var startY = e.pageY;
      var startWidth = ((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _element)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.getBoundingClientRect().width) || 0;
      var startHeight = ((_classPrivateFieldGet3 = _classPrivateFieldGet(this, _element)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.getBoundingClientRect().height) || 0;
      var onMouseMove = throttle(100, false, function (e) {
        var currentX = e.pageX;
        var currentY = e.pageY;
        var diffX = currentX - startX;
        var diffY = currentY - startY;
        var newWidth = null;
        var newHeight = null;

        if (_this2.aspectRatio === ResizableRatioType.Fixed && startWidth && startHeight) {
          switch (handle.type) {
            case ResizableHandleType.Right:
            case ResizableHandleType.BottomRight:
              newWidth = startWidth + diffX;
              newHeight = startHeight / startWidth * newWidth;
              break;

            case ResizableHandleType.Left:
            case ResizableHandleType.BottomLeft:
              newWidth = startWidth - diffX;
              newHeight = startHeight / startWidth * newWidth;
              break;

            case ResizableHandleType.Bottom:
              newHeight = startHeight + diffY;
              newWidth = startWidth / startHeight * newHeight;
              break;
          }
        } else if (_this2.aspectRatio === ResizableRatioType.Flexible) {
          switch (handle.type) {
            case ResizableHandleType.Right:
              newWidth = startWidth + diffX;
              break;

            case ResizableHandleType.Left:
              newWidth = startWidth - diffX;
              break;

            case ResizableHandleType.Bottom:
              newHeight = startHeight + diffY;
              break;

            case ResizableHandleType.BottomRight:
              newWidth = startWidth + diffX;
              newHeight = startHeight + diffY;
              break;

            case ResizableHandleType.BottomLeft:
              newWidth = startWidth - diffX;
              newHeight = startHeight + diffY;
              break;
          }
        }

        if (typeof newWidth === 'number' && newWidth < MIN_WIDTH) {
          if (_this2.aspectRatio === ResizableRatioType.Fixed && startWidth && startHeight) {
            newWidth = MIN_WIDTH;
            newHeight = startHeight / startWidth * newWidth;
          } else if (_this2.aspectRatio === ResizableRatioType.Flexible) {
            newWidth = MIN_WIDTH;
          }
        }

        if (newWidth) {
          _classPrivateFieldSet(_this2, _width, Math.round(newWidth));

          _this2.dom.style.width = "".concat(_classPrivateFieldGet(_this2, _width), "px");
        }

        if (newHeight) {
          _classPrivateFieldSet(_this2, _height, Math.round(newHeight));
        }

        if (newWidth || newHeight) {
          _this2.dom.style.aspectRatio = "".concat(_classPrivateFieldGet(_this2, _width), " / ").concat(_classPrivateFieldGet(_this2, _height));
        }
      });

      var onMouseUp = function onMouseUp(e) {
        e.preventDefault();
        handle.dataSetDragging(false);
        handle.setHandleVisibility(false);
        _classPrivateFieldGet(_this2, _element).style.pointerEvents = 'auto';
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        var pos = getPos();
        var tr = view.state.tr.setNodeMarkup(pos, undefined, _objectSpread(_objectSpread({}, _classPrivateFieldGet(_this2, _node).attrs), {}, {
          width: _classPrivateFieldGet(_this2, _width),
          height: _classPrivateFieldGet(_this2, _height)
        }));
        view.dispatch(tr);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    }
    /**
     * `update` will be called by Prosemirror, when the view is updating itself.
     */

  }, {
    key: "update",
    value: function update(node) {
      if (node.type !== _classPrivateFieldGet(this, _node).type) {
        return false;
      }

      if (this.aspectRatio === ResizableRatioType.Fixed && node.attrs.width && node.attrs.width !== _classPrivateFieldGet(this, _width)) {
        return false;
      }

      if (this.aspectRatio === ResizableRatioType.Flexible && node.attrs.width && node.attrs.height && node.attrs.width !== _classPrivateFieldGet(this, _width) && node.attrs.height !== _classPrivateFieldGet(this, _height)) {
        return false;
      }

      if (!isEqualWithoutAttrs(_classPrivateFieldGet(this, _node), node, ['width', 'height'])) {
        return false;
      }

      _classPrivateFieldSet(this, _node, node);

      _classPrivateFieldSet(this, _width, node.attrs.width);

      _classPrivateFieldSet(this, _height, node.attrs.height);

      return true;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _classPrivateFieldGet(this, _destroyList).forEach(function (removeEventListener) {
        return removeEventListener();
      });
    }
  }]);

  return ResizableNodeView;
}(); // Check if two nodes are equal by ignore some attributes


function isEqualWithoutAttrs(node1, node2, ignoreAttrs) {
  return node1 === node2 || sameMarkup(node1, node2, ignoreAttrs) && node1.content.eq(node2.content);
} // Compare the markup (type, attributes, and marks) of one node to those of
// another. Returns `true` if both have the same markup except some attributes.


function sameMarkup(node1, node2, ignoreAttrs) {
  var node1Attrs = node1.attrs;
  var node2Attrs = node2.attrs;
  var deltaAttrs = {};

  var _iterator2 = _createForOfIteratorHelper(ignoreAttrs),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var attr = _step2.value;
      deltaAttrs[attr] = null;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  node1.attrs = _objectSpread(_objectSpread({}, node1Attrs), deltaAttrs);
  node2.attrs = _objectSpread(_objectSpread({}, node2Attrs), deltaAttrs);
  var same = node1.sameMarkup(node2);
  node1.attrs = node1Attrs;
  node2.attrs = node2Attrs;
  return same;
}

function normalizeSize(size) {
  if (typeof size === 'number') {
    return "".concat(size, "px");
  } else if (size) {
    return size;
  } else {
    return undefined;
  }
}

export { ResizableNodeView, ResizableRatioType };